/* src/app/views/template/components/templates/print/print-card-templates/print-card-templates.component.scss */
/*# sourceMappingURL=print-card-templates.component.css.map */
